
import {Component, Vue} from 'vue-property-decorator'
import { VNode } from 'vue'

@Component({})
export default class GeDndPreview extends Vue {
    mounted() {
        const vNode = this.$parent?.$vnode

        if (!vNode) {
            return;
        }

        if (!vNode.data) {
            vNode.data = {}
        }

        if (!vNode.data.on) {
            vNode.data.on = {}
        }
        
        vNode.data.on.dnd_preview_element = () => {
            return this.$el
        }
    }

    unmounted() {
        const vNode = findParentDndVNode(this.$vnode)

        if (!vNode) {
            return;
        }

        delete vNode.data?.on?.dnd_preview_element 
    }
}

function findParentDndVNode(parent: VNode | undefined): VNode | null {
    while (parent) {
        if (parent.data?.directives?.find(it => {
            console.log(it.name)
            return it.name == "v-dnd"
        }
            )) {
            return parent
        }

        parent = parent.parent
    }

    return null
}

